import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  analytics: 0,
  partners: 0,
  withdraws:0
};

const pagePaginationSlice = createSlice({
  name: "pagePagination",
  initialState,
  reducers: {
    setPagePagination: (state, { payload }) => {
      state[payload.name] = payload.page;
    },
  },
});

export const pagePaginationSelector = (state) => state.pagePagination;

export const { setPagePagination } = pagePaginationSlice.actions;

export default pagePaginationSlice.reducer;
